import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_PRESSURE_GAUGES } from "../../../routes";
import { createPressureGauge } from "../actions/pressureGaugesActions";
import FormPage from "../../common/components/layout/FormPage";
import CreatePressureGaugeForm from "../components/CreatePressureGaugeForm";

class CreatePressureGauge extends FormPage {
  static propTypes = {
    pressureGauge: shape().isRequired,
    match: shape().isRequired,
    createPressureGauge: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * @param {object} pressureGauge
   */
  onSubmit(pressureGauge) {
    const { createPressureGauge, match } = this.props;
    const paramsPressureGauge = {
      clientUuid: match.params.uuid,
      ...pressureGauge,
    };

    createPressureGauge(paramsPressureGauge);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.pressure_gauges.add.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_PRESSURE_GAUGES;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { pressureGauge } = this.props;

    return (
      <CreatePressureGaugeForm
        loading={pressureGauge.saving}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  pressureGauge: state.pressureGauge,
});

const mapDispatchToProps = (dispatch) => ({
  createPressureGauge: (params) => dispatch(createPressureGauge(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePressureGauge);
